module.exports = __webpack_public_path__ + "img/huawei@2x.ae706a4d.png";